import { Backdrop } from '@mui/material';
import styled, { css } from 'styled-components';

import { Paper } from '@/shared/components/ui/paper/paper.styled';

export const TransparentBackdrop = styled(Backdrop)`
  && {
    background-color: transparent;
  }
`;

export const ModalContentContainer = styled(Paper)<{
  $transparent?: boolean;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-height: calc(100vh - 4rem);
  max-width: calc(100vw - 4rem);
  overflow: hidden;
  outline: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  ${({ $transparent }) =>
    $transparent
      ? css`
          && {
            background: transparent;
            box-shadow: none;
            border-radius: 0;
            padding: 0;
          }
        `
      : css`
          width: 400px;
        `}
`;
